import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetMainDealerQueryParams {
  id: number | string;
}

export const getMainDealer = async (
  props: QueryProps<GetMainDealerQueryParams>
): Promise<NewUser> => {
  const res = await api.client.get(`/dealers-new/${props.params.id}`, {
    signal: props.signal,
  });
  return res.data;
};
